import React from 'react';

import {useMediaStream} from '../hooks/userMedia';
import {Selfview} from '../views/Selfview/Selfview.view';

export const LocalStream: React.FC = () => {
    const stream = useMediaStream();
    return <Selfview stream={stream} />;
};
